import React from 'react';
import { TemplatesList } from '../../../../enums/TemplatesList';
import DefaultSlideSection from '../../../Templates/DefaultTemplate/Sections/Services/SlideSection/SlideSection';
import { CarouselItemI } from '../../../../interfaces/CarouselItemI';
import { Section } from '../../../../interfaces/Section';

export interface ServicesSliderSectionProps extends Section {
  sliderItems: Array<CarouselItemI>;
  slideClickAction: (id: string) => void;
}

const SlideSection = (props: ServicesSliderSectionProps) => {
  if (props.template === TemplatesList.MODERN) {
    return null;
  }
  return <DefaultSlideSection {...props} />;
};

export default SlideSection;
